<script setup>
/**
 * RED-355: the EVS 875-13:2024 annex C ESG table on the Kiirhindamine result
 * page — read-only, the same rows the lühiaruanne prints at ${esg-kokkuvote}.
 * Built from the ESG lookups the hydration already ran; before they resolve,
 * or with none at all, every factor reads „info puudub“ (the store never
 * returns an empty table). Collapsed by default: 49 rows.
 */
import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'
import EsgAnnexCTable from '@/components/detail/esg/EsgAnnexCTable.vue'
import { esgEvaluationText, useEsgStore } from '@/stores/useEsgStore'

const { quickValuationAnnexCRows: rows } = storeToRefs(useEsgStore())

const expanded = ref(false)

const filledCount = computed(
  () => rows.value.filter(row => esgEvaluationText(row) !== '').length,
)
</script>

<template>
  <div class="bg-white rounded-2xl shadow-xs border border-slate-100 p-6 mt-6" data-testid="qv-result-esg-annex-c">
    <div class="flex flex-wrap items-center justify-between gap-3">
      <div>
        <div class="flex items-center gap-2">
          <span class="pi pi-globe text-slate-500"></span>
          <h3 class="font-medium text-slate-800">{{ $t('messages.detail.esgAnnexC.title') }}</h3>
        </div>
        <p class="text-sm text-slate-500 mt-1" data-testid="qv-esg-annex-c-summary">
          {{ $t('messages.detail.esgAnnexC.filled', { filled: filledCount, total: rows.length }) }}
        </p>
      </div>
      <Button
        :label="expanded ? $t('messages.detail.esgAnnexC.hide') : $t('messages.detail.esgAnnexC.show')"
        :icon="expanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
        severity="secondary"
        text
        data-testid="qv-esg-annex-c-toggle"
        @click="expanded = !expanded"
      />
    </div>
    <div v-if="expanded" class="mt-4">
      <EsgAnnexCTable :value="rows" readonly />
    </div>
  </div>
</template>
